export default __webpack_public_path__ + "static/media/Stormrend Gauntlets.295b6d5a.jpg";